import {map} from 'lodash';
import {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {ConfirmModal, List, ListItem} from 'components';
import {TRANSLATION_KEYS} from 'locale';

const KEYS = TRANSLATION_KEYS.IN_SESSION_PAGE.REJECT_SESSION_DIALOG;

type Props = {
    open: boolean;
    values: string[];
    onClose: (confirm: boolean, value: string) => void;
};

export const ResultInformationDialog: React.FC<Props> = ({open, values: resultValues, onClose}: Props) => {
    const {t} = useTranslation();
    const [value, setValue] = useState();

    const handleClose = useCallback((confirm: boolean) => {
        onClose(confirm, confirm ? value : null);
        setValue(null);
    }, [value, onClose]);

    return (
        <ConfirmModal
            open={open}
            title={t(KEYS.TITLE)}
            fullWidth
            maxWidth='xs'
            okDisabled={!value}
            onClose={handleClose}
        >
            <List value={value} onChange={setValue}>
                {map(resultValues, ((resultValue, index) => <ListItem key={index} value={resultValue}>{resultValue}</ListItem>))}
            </List>
        </ConfirmModal>
    );
};
